import { PageContainer } from "@/components/container/page-container";
import { TermsAndConditionsContent } from "../welcome-screen/terms-content";

export default function PublicTermsPage() {
  return (
    <PageContainer
      showToolbar={false}
      className="app-bar-bottom-padding no-scrollbar h-full w-full overflow-y-auto"
    >
      <div className="mx-auto max-w-4xl px-6 py-8">
        <TermsAndConditionsContent />
      </div>
    </PageContainer>
  );
}
